"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var DOMException = require("domexception/webidl2js-wrapper");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLCollection = require("../generated/HTMLCollection");

var _require = require("../helpers/namespaces"),
    HTML_NS = _require.HTML_NS;

var _require2 = require("../helpers/traversal"),
    childrenByLocalNames = _require2.childrenByLocalNames;

var _require3 = require("../helpers/internal-constants"),
    domSymbolTree = _require3.domSymbolTree;

var cellLocalNames = new Set(["td", "th"]);

var HTMLTableRowElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLTableRowElementImpl, _HTMLElementImpl);

  function HTMLTableRowElementImpl() {
    _classCallCheck(this, HTMLTableRowElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLTableRowElementImpl).apply(this, arguments));
  }

  _createClass(HTMLTableRowElementImpl, [{
    key: "insertCell",
    value: function insertCell(index) {
      var td = this._ownerDocument.createElement("TD");

      var cells = this.cells;

      if (index < -1 || index > cells.length) {
        throw DOMException.create(this._globalObject, ["The index is not in the allowed range.", "IndexSizeError"]);
      }

      if (index === -1 || index === cells.length) {
        this._append(td);
      } else {
        var ref = cells.item(index);

        this._insert(td, ref);
      }

      return td;
    }
  }, {
    key: "deleteCell",
    value: function deleteCell(index) {
      var cells = this.cells;

      if (index < -1 || index >= cells.length) {
        throw DOMException.create(this._globalObject, ["The index is not in the allowed range.", "IndexSizeError"]);
      }

      if (index === -1) {
        if (cells.length === 0) {
          return;
        }

        index = cells.length - 1;
      }

      var td = cells.item(index);

      this._remove(td);
    }
  }, {
    key: "cells",
    get: function get() {
      var _this = this;

      if (!this._cells) {
        this._cells = HTMLCollection.createImpl(this._globalObject, [], {
          element: this,
          query: function query() {
            return childrenByLocalNames(_this, cellLocalNames);
          }
        });
      }

      return this._cells;
    }
  }, {
    key: "rowIndex",
    get: function get() {
      var parent = this.parentElement;

      if (parent === null || parent.namespaceURI !== HTML_NS) {
        return -1;
      }

      var tableElement = parent;

      if (parent.localName === "thead" || parent.localName === "tbody" || parent.localName === "tfoot") {
        tableElement = parent.parentElement;
      }

      if (tableElement === null || tableElement.namespaceURI !== HTML_NS || tableElement.localName !== "table") {
        return -1;
      }

      return tableElement.rows.indexOf(this);
    }
  }, {
    key: "sectionRowIndex",
    get: function get() {
      var parent = domSymbolTree.parent(this);

      if (parent === null) {
        return -1;
      }

      var rows = parent.rows;

      if (!rows) {
        return -1;
      }

      return rows.indexOf(this);
    }
  }]);

  return HTMLTableRowElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLTableRowElementImpl
};